import { useForm } from "react-hook-form";
import { MOBILE_MONEY_PROVIDERS } from "../../../shared/mobileMoneyProviders";

const msisdn = (v) => {
  if (!v?.trim()) return "Phone number is required";
  const trimmed = v.trim();
  if (!/^\d+$/.test(trimmed)) return "Phone number must contain digits only";
  if (trimmed.length >= 4 && !/^254[71]/.test(trimmed))
    return "Phone number must start with '2547' or '2541'";
  if (trimmed.length !== 12)
    return "Phone number must be exactly 12 digits (e.g., 2547XXXXXXXX)";
  return null;
};

const ALLOWED_PROVIDERS = MOBILE_MONEY_PROVIDERS.map((p) => p.value);

export const validationSchemas = {
  // FUTURE RELEASE: Top-level msisdn validator used in BankAccountStep1 for phone number bank verification.
  // Re-enable when MSISDN bank verification is supported. The validator itself (above) stays
  // because it is still used by mobileMoneyValidators for M-Pesa accounts.
  // msisdn,

  mobileMoneyValidators: {
    msisdn,
    provider: (v, allowedProviders = ALLOWED_PROVIDERS) => {
      if (!v) return "Provider is required";
      return allowedProviders.includes(v)
        ? null
        : `Provider must be ${allowedProviders.join(" or ")}`;
    },
    accountName: (v) => (v ? null : "Account name is required"),
  },

  bankAccountValidators: {
    accountName: (v) => (v ? null : "Account name is required"),
    accountNumber: (v) => {
      const trimmed = v.trim();
      if (!/^\d+$/.test(trimmed)) {
        return "Account number must contain digits only";
      }
      if (trimmed.length < 8 || trimmed.length > 20) {
        return "Account number must be between 8 and 20 digits";
      }
      return null;
    },
    bankName: (v) => (v ? null : "Bank name is required"),
  },

  paykitWalletValidators: {
    accountName: (v) => (v ? null : "Account name is required"),
    accountNumber: (v) => {
      const trimmed = v.trim();
      if (!/^\d+$/.test(trimmed)) {
        return "Account number must contain digits only";
      }
      if (trimmed.length < 8 || trimmed.length > 12) {
        return "Account number must be between 8 and 12 digits";
      }
      return null;
    },
  },
};

const defaultValues = {
  mobile: {
    msisdn: "",
    provider: null,
    accountName: "",
    isDefaultPayout: false,
  },
  bank: {
    accountName: "",
    accountNumber: "",
    bankName: "",
    swiftCode: "",
    branchCode: "",
    isDefaultPayout: false,
  },
  wallet: {
    accountName: "",
    accountNumber: "",
    isDefaultPayout: false,
  },
};

export const useAccountForm = (accountType) => {
  const { control, handleSubmit, reset, setValue } = useForm({
    defaultValues: defaultValues[accountType],
    mode: "onTouched",
  });

  return { control, handleSubmit, reset, setValue };
};

export default useAccountForm;
